import '../scss/frontend.scss';

import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import { Fancybox } from '@fancyapps/ui';

document.addEventListener('DOMContentLoaded', () => {
	function imageFade() {
		let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.remove('fade-out');
				} else {
					entry.target.classList.add('fade-out');
				}
			});
		});
		document.querySelectorAll('.timeline__item').forEach((img) => {
			observer.observe(img);
		});
	}
	imageFade();

	function SwipersInit() {
		const swipers = document.querySelectorAll('.swiper');

		swipers.forEach((swiperEl) => {
			if (swiperEl.classList.contains('swiper-home-slider')) {
				const links = document.querySelectorAll('.section-home-slider__navigation-item');
				const swiper = new Swiper(swiperEl, {
					modules: [Autoplay],
					loop: true,
					autoplay: {
						delay: 5000,
					},
					on: {
						init: function (event) {
							links[0].classList.add('active');
						},
						slideChangeTransitionStart: function (event) {
							const current = event.activeIndex == 1 || event.activeIndex == 5 ? 0 : event.activeIndex - 1;
							links.forEach((link) => link.classList.remove('active'));
							links[current].classList.add('active');
						},
					},
				});
				links.forEach((link) => {
					link.addEventListener('mouseenter', (event) => {
						swiper.slideTo(link.dataset.index);
					});
				});
			} else if (swiperEl.classList.contains('swiper-reviews')) {
				const swiper = new Swiper(swiperEl, {
					modules: [Pagination, Autoplay],
					loop: true,
					autoplay: {
						delay: 10000,
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			} else if (swiperEl.classList.contains('swiper-timeline')) {
				const swiper = new Swiper(swiperEl, {
					modules: [Pagination, Navigation, Autoplay],
					autoplay: {
						delay: 5000,
						disableOnInteraction: true,
					},
					slidesPerView: 1,
					spaceBetween: 30,
					grabCursor: true,
					autoHeight: true,
					// pagination: {
					// 	el: '.swiper-pagination',
					// 	type: 'progressbar',
					// 	clickable: true,
					// },
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 30,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 30,
						},
					},
				});
			} else if (swiperEl.classList.contains('swiper-text-image')) {
				const swiper = new Swiper(swiperEl, {
					modules: [Autoplay, Pagination, EffectFade],
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
					speed: 1000,
					loop: true,
					effect: 'fade',
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			}
		});
	}
	SwipersInit();

	function PDFtargetBlank() {
		const links = document.querySelectorAll('a[href$=".pdf"]');

		links.forEach((link) => {
			link.setAttribute('target', '_blank');
		});
	}
	PDFtargetBlank();

	// Initialize and add the map
	function initMap() {
		if (!document.getElementById('section-map__map')) return;
		const map = new google.maps.Map(document.getElementById('section-map__map'), {
			zoom: 2,
			center: new google.maps.LatLng(37.4419, -1.7732),
		});

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const centreParam = urlParams.get('centre');
		var prev_infowindow = false;

		map.markers = [];

		const markerELs = document.querySelectorAll('.section-map__location');

		markerELs.forEach((markerEl) => {
			var lat = markerEl.dataset.lat;
			var lng = markerEl.dataset.lng;
			var latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			};

			// // Create marker instance.
			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
			});

			// Append to reference for later use.
			map.markers.push(marker);

			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: markerEl.innerHTML,
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function () {
				if (prev_infowindow) {
					prev_infowindow.close();
				}

				prev_infowindow = infowindow;
				infowindow.open(map, marker);
			});

			// Using the same function as above, due to encoding issues
			var service_centre = new URLSearchParams('centre=' + markerEl.dataset.centre).get('centre');

			if (service_centre == centreParam) {
				infowindow.open(map, marker);
			}
		});

		centerMap(map);

		return map;
	}

	function centerMap(map) {
		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function (marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			});
		});

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
		}
	}

	initMap();

	function autoCompleteCourseName() {
		const training_forms = document.querySelectorAll('.training-form');

		training_forms.forEach((training_form) => {
			const course = training_form.dataset.course;
			const input = training_form.querySelector('input[name="your-subject"]');
			input.value = course;
		});
	}
	autoCompleteCourseName();
});

// Mailchimp validation
(function ($) {
	window.fnames = new Array();
	window.ftypes = new Array();
	fnames[0] = 'EMAIL';
	ftypes[0] = 'email';
})(jQuery);
var $mcj = jQuery.noConflict(true);

Fancybox.bind('[data-fancybox]', {
	Toolbar: false,
	closeButton: 'top',
	click: false,
	dragToClose: false,
});
